<template>
  <v-dialog
    v-model="dialogShowHelpComputed"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card class="grey lighten-5">
      <v-card-title>
        <v-img
          :max-height="$vuetify.breakpoint.smAndDown ? 35 : 45"
          :max-width="$vuetify.breakpoint.smAndDown ? 70 : 200"
          position="left"
          contain
          :alt="logo.alt"
          :src="$vuetify.breakpoint.smAndDown ? logo.src.xs : logo.src.normal"
        >
        </v-img>
        <v-spacer></v-spacer>
        <v-btn
          @click="setDialogShowHelp(false)"
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <v-row>
          <v-col
            cols="12"
            :class="`d-flex justify-center ${$vuetify.breakpoint.smAndDown
              ? 'title' : 'display-2'} font-weight-bold grey--text text--darken-3`"
          >
            Hello, how can we help you?
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-text-field
              v-model="searchHelp"
              style="max-width: 800px"
              filled
              rounded
              dense
              placeholder="Search"
              prepend-inner-icon="mdi-magnify"
              hide-details
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="!searchHelp && !helps.length">
          <v-col class="d-flex justify-center grey--text mt-8">
            <information-message
              :size="100"
              icon="emoticon-sad"
              title="Sorry, no help is available at this time"
              subtitle="Administrators are working on it"
              color="grey"
              style="opacity: 0.5"
            >
            </information-message>
          </v-col>
        </v-row>
        <v-row v-if="searchHelp && !helpFilter.length">
          <v-col class="d-flex justify-center grey--text mt-8">
            <information-message
              :size="100"
              icon="card-bulleted-off"
              title="No help found related to your search"
              subtitle="Please try another search"
              color="grey"
              style="opacity: 0.5"
            >
            </information-message>
          </v-col>
        </v-row>
        <div v-if="!searchHelp && helps.length">
          <v-row>
            <v-col :class="`d-flex justify-center ${$vuetify.breakpoint.smAndDown
              ? 'caption' : ''} grey--text my-4 text-center`">
              or choose a category to quickly find the help you need
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="d-flex flex-wrap justify-center"
            >
              <div
                v-for="option in optionsComputed"
                :key="option.title"
                :option="option"
                class="ma-3"
              >
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    :max-width="200"
                    :min-width="200"
                    :style="`boxShadow: 0px ${(optionSelected
                      && optionSelected.id === option.id) || hover
                      ? '6px 35px rgba(0, 0, 0, 0.2)'
                      : '6px 30px rgba(0, 0, 0, 0)'} !important; border-radius: 7px`"
                    @click.stop="optionSelected = option"
                    :color="(optionSelected && optionSelected.id === option.id)
                      ? 'primary' : 'grey lighten-5'"
                    :class="[
                      { 'on-hover': hover || (optionSelected && optionSelected.id === option.id) },
                      `${$vuetify.breakpoint.smAndDown ? 'py-2' : 'py-5'}`,
                      'pointer',
                      'px-6',
                      'd-flex align-center flex-column justify-center fill-height',
                  ]">
                    <div class="justify-center align-center d-flex flex-wrap">
                      <v-icon
                        :size="50"
                        :color="(optionSelected && optionSelected.id === option.id)
                          ? 'white' : 'primary'"
                      >
                        {{ option.icon }}
                      </v-icon>
                    </div>

                    <v-card-title
                      :class="[
                        'caption',
                        'font-weight-bold',
                        `${(optionSelected && optionSelected.id === option.id)
                          ? 'white--text' : 'primary--text'}`,
                        'd-flex',
                        'justify-center',
                        'text-center',
                        'word-break',
                        'font-weight-bold',
                        'pb-1'
                      ]">
                      {{ titleUpperCase(option.title) }}
                    </v-card-title>
                  </v-card>
                </v-hover>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col class="mt-4">
            <v-expansion-panels accordion flat>
              <v-expansion-panel
                v-for="(help, index) in helpFilter"
                :key="index"
              >
                <v-expansion-panel-header
                  class="grey lighten-4"
                >
                  <span :class="`font-weight-bold ${$vuetify.breakpoint.smAndDown
                      ? 'body-2' : 'title'} d-flex align-center`">
                    <v-icon small class="mr-3" color="grey darken-3">
                      mdi-circle
                    </v-icon>
                    <span class="grey--text text--darken-3 d-flex flex-wrap align-center">
                      <span v-if="searchHelp" class="d-flex align-center mr-2">
                        <v-icon color="primary" class="mr-2">{{ help.option.icon }}</v-icon>
                        <span class="primary--text">
                          {{ help.option.title.toUpperCase() }}:
                        </span>
                      </span>
                      <span>
                        {{ help.title }}
                      </span>
                    </span>
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-5" >
                  <v-container :class="`${$vuetify.breakpoint.smAndDown
                    ? 'pa-0' : ''}`">
                    <v-row>
                      <v-col style="overflow: auto">
                        <div :class="`${$vuetify.breakpoint.smAndDown
                          ? 'pa-0' : ''} quill-container`">
                            <div :class="`${$vuetify.breakpoint.smAndDown
                          ? 'px-0' : ''} ql-editor`">
                            <div v-html="help.description"></div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapMutations, mapState, mapActions } from 'vuex';
import urlLogoNormal from '@/assets/logo.png';
import urlLogoXs from '@/assets/logo-xs.png';

import InformationMessage from '@/components/InformationMessage.vue';

export default {
  components: {
    'information-message': InformationMessage,
  },
  data() {
    return {
      logo: {
        alt: 'Axoscape',
        src: {
          normal: urlLogoNormal,
          xs: urlLogoXs,
        },
      },
      allOptions: [
        {
          id: 'project_startup',
          icon: 'mdi-folder-plus',
          title: 'project startup',
          to: { name: 'project-startup' },
          description: 'Create projects in BIM 360',
        },
        {
          id: 'projects_administration',
          icon: 'mdi-folder-settings',
          title: 'PROJECTS ADMINISTRATION',
          to: { name: 'projects-administration' },
          description: 'Batch configure BIM 360 projects status and its users',
        },
        {
          id: 'access_projects',
          icon: 'mdi-folder-key',
          title: 'ACCESS PROJECTS',
          to: { name: 'access-projects' },
          description: 'lorem lreom relore lorem lore kore lorem lore lore rloe lroe',
        },
        {
          id: 'viewer',
          icon: 'mdi-cube-scan',
          title: 'viewer',
          to: { name: 'viewer' },
          description: 'Visualize, review and share 2d and 3d documents hosted in BIM 360',
        },
        {
          id: 'dashboard',
          icon: 'mdi-monitor-dashboard',
          title: 'dashboard',
          to: { name: 'dashboard' },
          description: 'Visualize, review and share 2d and 3d documents hosted in BIM 360',
        },
        {
          id: 'publish_model',
          icon: 'mdi-calendar-clock',
          title: 'PUBLISH MODEL',
          to: { name: 'publish-model' },
          description: 'Publish the latest updates of Revit models',
        },
        {
          id: 'international_framework_content',
          icon: 'mdi-image-outline',
          title: 'International framework content',
          to: { name: 'international-framework-content' },
          description: 'Explore sheets and views of regional framework templates',
        },
        // {
        //   id: 'api_documentation',
        //   icon: 'mdi-api',
        //   title: 'API DOCUMENTATION',
        //   to: { name: 'api-documentation axoscape data' },
        //   description: 'Endpoints API Documentation',
        // },
        {
          id: 'app_settings',
          icon: 'mdi-cog',
          title: 'APP SETTING',
          to: { name: 'app-settings' },
          description: 'General application settings',
        },
      ],
      isActiveOption: false,
      options: [],
      optionSelected: '',
      helps: [],
      searchHelp: '',
    };
  },
  computed: {
    ...mapState(['showDownloads', 'expandDownloads', 'downloads', 'dialogShowHelp']),
    ...mapState('profile', ['userLoggedIn']),
    helpsComputed() {
      return this.helps.reduce((acc, el) => {
        if (!acc[el.category]) acc[el.category] = [];
        acc[el.category].push(el);
        return acc;
      }, {});
    },
    dialogShowHelpComputed: {
      get() { return this.dialogShowHelp; },
      set(value) { return this.setDialogShowHelp(value); },
    },
    optionsComputed() {
      const keysCategory = Object.keys(this.helpsComputed);
      return this.options.filter(option => keysCategory.includes(option.id));
    },
    helpFilter() {
      return this.searchHelp
        ? this.helps
          .filter(help => help.title.toLowerCase().includes(this.searchHelp.toLowerCase()))
        : this.helps.filter(help => help.category === this.optionSelected.id);
    },
  },
  methods: {
    ...mapMutations(['setDialogShowHelp']),
    ...mapActions('service/help', ['retriveHelps', 'createHelp', 'updateHelp', 'deleteHelp']),
    getOptions() {
      const services = this.userLoggedIn.services
        .map((service) => {
          const keyService = Object.keys(service).find(key => (key !== 'permissions' && key !== 'conditions'));
          return { [keyService]: service[keyService] };
        })
        .filter(service => Object.values(service)[0])
        .map(service => Object.keys(service)[0]);
      this.options = this.allOptions
        .filter(option => services.includes(option.id));
    },
    titleUpperCase(title) {
      return title.toUpperCase();
    },
    async getHelps() {
      try {
        this.loading = true;
        this.helps = await this.retriveHelps();
        this.helps = this.helps.map(help => ({
          ...help,
          option: this.allOptions.find(option => option.id === help.category),
        }));
      } catch (error) {
        // console.log(error);
        // console.log(error.response);
        this.alertResult = true;
        this.alertType = 'error';
        this.alertMessage = `Error: ${error.response ? error.response.data.message : error.message}`;
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getOptions();
    this.getHelps();
  },
};
</script>

<style scoped>
  .on-hover {
    transition: ease .3s all;
    transform: translateY(-5px) scale(1.01);
  }
</style>
